import { render, staticRenderFns } from "./AddCurriculam.vue?vue&type=template&id=0a3f916c&scoped=true"
import script from "./AddCurriculam.vue?vue&type=script&lang=js"
export * from "./AddCurriculam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3f916c",
  null
  
)

export default component.exports